interface TITLES_OPTIONS_INTERFACE {
  [key: string]: {
    carTitle: string;
    // driveTitle: string;
  };
}

const TITLES_OPTIONS: TITLES_OPTIONS_INTERFACE = {
  DEFAULT: {
    carTitle: 'Carros',
    // driveTitle: 'Motorista',
  },
  SHIP: {
    carTitle: 'Balsas',
    // driveTitle: 'balseiro',
  },
};

const TITLES = process.env.REACT_APP_TITLE_TYPES
  ? TITLES_OPTIONS[process.env.REACT_APP_TITLE_TYPES]
  : TITLES_OPTIONS.DEFAULT;
export default TITLES;
